import { render, staticRenderFns } from "./DataFormModal.vue?vue&type=template&id=310dc67c"
import script from "./DataFormModal.vue?vue&type=script&lang=js"
export * from "./DataFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports